// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-2[data-v-3fa6b0a7]{gap:8px}", ""]);
// Exports
module.exports = exports;
